import styled, { css } from 'styled-components';
import { PX_TO_REM, PxToRem, SIZES } from '../../fundamentals/sizes/sizes';
import { IShadowProps, SHADOW_TYPES, useShadowCss } from '../../fundamentals/shadows/shadows';
import { IBorderRadiusProps, useBorderRadiusCss } from '../../fundamentals/sizes/borderRadius';
import { Z_INDICES } from '../../common/constants';
import { BaseDiv } from '../../common/BaseElements';
import { UseDropdownMenuOptions } from 'react-overlays/esm/DropdownMenu';

export type MenuSize = typeof SIZES.XX_SMALL | typeof SIZES.X_SMALL | typeof SIZES.SMALL | typeof SIZES.MEDIUM;

export interface IMenuBaseProps {
  size?: MenuSize;
  compact?: boolean;
  asDropdown?: boolean;
  asSheet?: boolean;
  multiple?: boolean;
  debounceInMs?: number;
  asMenu?: boolean;
}

const width: Record<MenuSize, PxToRem> = {
  [SIZES.XX_SMALL]: PX_TO_REM[224],
  [SIZES.X_SMALL]: PX_TO_REM[256],
  [SIZES.SMALL]: PX_TO_REM[320],
  [SIZES.MEDIUM]: PX_TO_REM[336]
};

export const DDMENU_SHADOW_SIZE = SHADOW_TYPES.BOLD;

type MenuCssProps = IBorderRadiusProps & IShadowProps & { itemSize?: MenuSize; noWrap?: boolean };

const useMenuAsDropdownCss = css<MenuCssProps>`
  min-width: ${(props) => (props.itemSize ? width[props.itemSize] : width[SIZES.XX_SMALL])};
  max-width: ${width[SIZES.MEDIUM]};
  white-space: ${(props) => (props.noWrap ? 'nowrap' : 'normal')};
  ${useShadowCss()};
  ${useBorderRadiusCss()};
  z-index: ${Z_INDICES.DD_POPPER};
`;

export const DDMENU_BORDER_RADIUS_SIZE = SIZES.MEDIUM;

export const MenuBase = styled(BaseDiv).attrs<IMenuBaseProps & MenuCssProps & Pick<UseDropdownMenuOptions, 'show'>>(
  ({ shadow = DDMENU_SHADOW_SIZE, borderRadius = DDMENU_BORDER_RADIUS_SIZE, ...rest }) => ({
    shadow,
    borderRadius,
    ...rest
  })
)<IMenuBaseProps & MenuCssProps & Pick<UseDropdownMenuOptions, 'show'>>`
  background-color: ${({ theme }) => theme.colours.eoraCoreColours.BACKGROUND_COLOR.PANEL_COLOR_BACKGROUND};

  ${({ asDropdown }) => asDropdown && useMenuAsDropdownCss}
  ${({ show }) => {
    return (
      show &&
      css`
        border: ${PX_TO_REM[1]} solid ${({ theme }) => theme.colours.eoraCoreColours.BORDER_COLOR.COLOR_BORDER_LIGHT};
      `
    );
  }}
`;
